import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService, FileService, MessageService, ProcedureService,TrackingService } from '@services';
import { formatDate } from '@angular/common';
import { AppBaseComponent } from "@utils";
import { lastValueFrom, Subscription } from "rxjs";

@Component({
  selector: 'app-edit-info',
  templateUrl: './edit-info.component.html',
  styleUrls: ['./edit-info.component.scss']
})

export class EditInfoComponent extends AppBaseComponent implements OnInit {

  solicitudForm: FormGroup;
  @Input() tramiteActual: any;
  @Input() trackingTramiteActual: any;
  isLegalPerson: boolean = false;

  isModification: boolean = false;

  isRenewal: boolean = false;

  sending: boolean = false;
  files: any[] = [];

  logged: boolean = false;

  subscriptionFileService: Subscription;
  subscriptionLogged: Subscription;

  constructor(
    private fb: FormBuilder,
    private popupAlert: MessageService,
    private fileService: FileService,
    private authService: AuthService,
    private procedureService: ProcedureService,
    private trackingService: TrackingService
  ) {
    super();
  }

  ngOnInit(): void {

    this.solicitudForm = this.fb.group({
      id: [],
      processId: [],
      filedNumber: [],
      date: [],
      lastStatusDate: [],
      userId: [],
      modificationForm: this.fb.group(
        {
          reasonModificationId: [''],
          resolutionToModify: [''],
          dateResolutionToModify: [''],
          file: [''],
          licenciaVigenteFile: [''],
          soporteModificacionFile: [''],
          fileSoporte: ['']
        }
      ),
      renewalForm: this.fb.group(
        {
          renovationDepartmentId: [''],
          renovationMunicipalityId: [''],
          resolutionToModify: [''],
          dateResolutionToModify: [''],
          file: [''],
          licenciaAnteriorFile: ['']
        }
      ),
      laborForm: this.fb.group({
        companyWorking: [],
        companyName: [],
        companyAddress: [],
        companyDepartmentId: [],
        companyMunicipalityId: [],
        companyPhone: [],
        companyCellPhone: [],
        companyFax: [],
      }),
      typeServiceForm: this.fb.group({
        servicesToProvide: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(100)]],
        basicCharacteristicsServices: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(100)]],
        otherServices: ['', [Validators.maxLength(100)]]
      }),
      attachmentForm: this.fb.group(
        {
          programTypeId: [null, [Validators.required]],
          titleTypeId: [null, [Validators.required]],
          typeProfessionalId: [null, [Validators.required]],
          titleProfessionalName: ['', [Validators.required, Validators.minLength(5)]],
          titleDoctorateName: ['', [Validators.required, Validators.minLength(5)]],
          otherProfessionalName: ['', [Validators.required, Validators.minLength(5)]],
          entityAddress: ['', Validators.minLength(5)],
          quantityDocuments: []
        }
      )
    });


    this.solicitudForm.get('laborForm.companyWorking')!.valueChanges
      .subscribe(value => {
        if (value) {
          console.log(value);
          if (value == '1') this.setOrRemoveValidatorsIfWorking(1);
          if (value == '2') this.setOrRemoveValidatorsIfWorking(0);
        }
      });

    this.subscriptionFileService = this.fileService.getFilesAdded$
      .subscribe(resp => {
        if (resp) this.files = resp;
      });

    this.subscriptionLogged = this.authService.currentUser$
      .subscribe(resp => {
        console.log(resp);
        this.logged = !!resp;
      });

    this.isLegalPerson = this.tramiteActual.personTypeId == 2;
    this.isModification = this.tramiteActual.processId == 2;
    this.isRenewal = this.tramiteActual.processId == 3;

    if (this.isLegalPerson) {
      setTimeout(() => {
        this.clearValidatorsAttachmentsFrm();
      }, 1000);
      this.solicitudForm.get('attachmentForm.entityAddress').setValidators([Validators.required, Validators.minLength(5)]);
      this.solicitudForm.get('attachmentForm.entityAddress').updateValueAndValidity();
    }

    //Pintar la informacion del tramite actual
    this.loadInfoTramiteActual();
  }

  ngOnDestroy() {
    if (this.subscriptionFileService) {
      this.subscriptionFileService.unsubscribe();
    }

    if (this.subscriptionLogged) {
      this.subscriptionLogged.unsubscribe();
    }

    this.solicitudForm.reset();
  }

  loadInfoTramiteActual(): void {

    switch (this.tramiteActual.processId.toString()) {
      case '1':
        this.setOrRemoveValidatorsInModify(0);
        this.setOrRemoveValidatorsInRenew(0);
        break;
      case '2':
        this.setOrRemoveValidatorsInModify(1);
        this.setOrRemoveValidatorsInRenew(0);
        break;
      case '3':
        this.setOrRemoveValidatorsInModify(0);
        this.setOrRemoveValidatorsInRenew(1);
        break;
    }

    this.solicitudForm.get('id').setValue(this.tramiteActual.id);

    this.solicitudForm.get('date').setValue(this.tramiteActual.date);
    this.solicitudForm.get('userId').setValue(this.tramiteActual.userId);

    this.solicitudForm.get('processId').setValue(this.tramiteActual.processId);
    this.solicitudForm.get('filedNumber').setValue(this.tramiteActual.filedNumber);

    this.solicitudForm.get('laborForm.companyWorking').setValue(this.tramiteActual.companyWorking.toString());
    this.solicitudForm.get('laborForm.companyName').setValue(this.tramiteActual.companyName);
    this.solicitudForm.get('laborForm.companyAddress').setValue(this.tramiteActual.companyAddress);
    this.solicitudForm.get('laborForm.companyDepartmentId').setValue(this.tramiteActual.companyDepartmentId);
    this.solicitudForm.get('laborForm.companyMunicipalityId').setValue(this.tramiteActual.companyMunicipalityId);
    this.solicitudForm.get('laborForm.companyPhone').setValue(this.tramiteActual.companyPhone);
    this.solicitudForm.get('laborForm.companyCellPhone').setValue(this.tramiteActual.companyCellPhone);

    this.solicitudForm.get('typeServiceForm.servicesToProvide').setValue(this.tramiteActual.servicesToProvide);
    this.solicitudForm.get('typeServiceForm.basicCharacteristicsServices').setValue(this.tramiteActual.basicCharacteristicsServices);
    this.solicitudForm.get('typeServiceForm.otherServices').setValue(this.tramiteActual.otherServices);

    this.solicitudForm.get('attachmentForm.programTypeId').setValue(this.tramiteActual.programTypeId);
    this.solicitudForm.get('attachmentForm.titleTypeId').setValue(this.tramiteActual.titleTypeId);
    this.solicitudForm.get('attachmentForm.typeProfessionalId').setValue(this.tramiteActual.typeProfessionalId);
    this.solicitudForm.get('attachmentForm.titleProfessionalName').setValue(this.tramiteActual.titleProfessionalName);
    this.solicitudForm.get('attachmentForm.titleDoctorateName').setValue(this.tramiteActual.titleDoctorateName == '' ? 'No aplica' : this.tramiteActual.titleDoctorateName);
    this.solicitudForm.get('attachmentForm.otherProfessionalName').setValue(this.tramiteActual.otherProfessionalName == '' ? 'No aplica' : this.tramiteActual.otherProfessionalName);
    this.solicitudForm.get('attachmentForm.entityAddress').setValue(this.tramiteActual.entityAddress);

    this.solicitudForm.get('modificationForm.reasonModificationId').setValue(this.tramiteActual.reasonModificationId);
    this.solicitudForm.get('modificationForm.resolutionToModify').setValue(this.tramiteActual.resolutionToModify);
    this.solicitudForm
      .get('modificationForm.dateResolutionToModify')
      .setValue(
        formatDate(new Date(this.tramiteActual.dateResolutionToModify), 'yyyy-MM-dd', 'en'));

    this.solicitudForm.get('renewalForm.resolutionToModify').setValue(this.tramiteActual.resolutionToModify);
    this.solicitudForm
      .get('renewalForm.dateResolutionToModify')
      .setValue(formatDate(new Date(this.tramiteActual.dateResolutionToModify), 'yyyy-MM-dd', 'en'));

  }

  async saveValidation() {
    this.validacionesCamposPostgradoUOtroProfesional();

    const formData = this.solicitudForm.value;
    const personTypeId: number = this.isLegalPerson ? 2 : 1; // si el usuario es juridica o ntural -> modificar posteriormente
    const procedureType = this.solicitudForm.get('processId').value;
    const id = this.solicitudForm.get('id').value;
    const filedNumber = this.solicitudForm.get('filedNumber').value;
    const date = this.solicitudForm.get('date').value;
    const lastStatusDate = new Date(Date.now())
    const userId = this.solicitudForm.get('userId').value;
    const laborFrm = formData['laborForm'];
    const typeServiceFrm = formData['typeServiceForm'];
    const attachmentForm = formData['attachmentForm'];
    const modificationForm = formData['modificationForm'];
    const renewalForm = formData['renewalForm'];
    let requestToSave = { ...laborFrm, ...typeServiceFrm, ...attachmentForm, licenseToModifyPath: null, personTypeId };

    // modificacion
    if (procedureType == 2) requestToSave = { ...requestToSave, ...modificationForm }
    // renovacion
    if (procedureType == 3) requestToSave = { ...requestToSave, ...renewalForm }

    if (!this.solicitudForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de la solicitud, hay datos invalidos y/o incompletos.`,
        4000
      );
      console.log("FORMULARIO PROCESADO");
      console.log(this.solicitudForm.value);
      console.log("ERRORES FORMULARIO");
      console.log(super.getAllErrors(this.solicitudForm));
      this.solicitudForm.markAllAsTouched();
      return;
    }

    if (this.files.length == 0) {
      this.popupAlert.errorAlert(
        'No se encontraron archivos adjuntos, ¡revise por favor!',
        4000);
      return;
    }

    let cantidadDocumentos = attachmentForm.quantityDocuments;

    console.log("files lenght", this.files.length);
    console.log("cantidadDocumentos", cantidadDocumentos);

    if (this.files.length < cantidadDocumentos) {
      this.popupAlert.errorAlert(
        'Hay requisitos sin documento adjunto, ¡revise por favor!',
        4000);
      return;
    }

    delete requestToSave.quantityDocuments;

    this.sending = true;
    requestToSave = {
      ...requestToSave,
      id: id,
      userId: userId,
      statusId: 8,
      date: date,
      lastStatusDate: lastStatusDate,
      filedNumber: filedNumber,
      processId: this.solicitudForm.get('processId').value, // 1=> PRIMERA VEZ, 2 => MODIFICACION, 3=> RENOVACION
      documentSuppors: []
    };

    this.popupAlert.infoAlert(
      `<b>Guardando...</b> Puede tardar un poco, no actualice o recarge la página, un momento por favor`,
      4000
    );

    for (const newFile of this.files) {
      const fmData = new FormData();
      fmData.append('File', newFile.contenido);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: newFile.docTypeId,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
        }).catch(err => {
          console.error('Error al adjuntar documento: ' + newFile.docTypeId);
        });
    }

    if (procedureType == 2 && requestToSave.licenciaVigenteFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.licenciaVigenteFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 13,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.file;
          delete requestToSave.licenciaVigenteFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia vigente', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.licenciaVigenteFile?.name);
        });
    }

    if (procedureType == 2 && requestToSave.soporteModificacionFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.soporteModificacionFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 15,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.fileSoporte;
          delete requestToSave.soporteModificacionFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia vigente', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.soporteModificacionFile?.name);
        });
    }

    if (procedureType == 3 && requestToSave.licenciaAnteriorFile) {
      const fmData = new FormData();
      fmData.append('File', requestToSave.licenciaAnteriorFile);
      await lastValueFrom(this.fileService.saveFile(fmData))
        .then(resp => {
          requestToSave.documentSuppors
            .push({
              documentTypeId: 14,
              path: resp.absoluteUri,
              registrationDate: new Date(Date.now())
            });
          delete requestToSave.file;
          delete requestToSave.licenciaAnteriorFile;
        }).catch(err => {
          this.popupAlert.errorAlert('Error al guardar la licencia anterior', 2000);
          console.error('Error al adjuntar documento: ' + requestToSave.licenciaAnteriorFile?.name);
        });
    }

    // tslint:disable-next-line: no-unused-variable
    this.procedureService.updateProcedureRequest(id, requestToSave).subscribe(resp => {
        this.sending = false;

        console.log("TRAMITE PROCESADO")
        console.log(requestToSave)

        console.log("Respuesta editado", resp)

        let tracking = {
          "statusId": "8",
          "observation": "Subsanación usuario externo",
          "procedureRequestId": id
        }
      // tslint:disable-next-line: no-unused-variable
        this.trackingService.saveTracking(tracking).subscribe(resp => {
          this.sending = false;
          console.log("TRACKING GUARDADO");
          console.log(tracking)
          console.log(resp);
          this.popupAlert.successAlert(
            'Su solicitud se ha registrado satisfactoriamente!',
            4000);
          location.reload();
        }, error => {
          this.sending = false;
          console.log("TRACKING FALLIDO");
          console.log(tracking)
          this.popupAlert.errorAlert(
            'Ocurrió un error al guardar el seguimiento',
            4000);
          console.log(error);
        });
      }, error => {
        this.sending = false;
        this.popupAlert.errorAlert(
          'Ocurrió un error al guardar la solicitud',
          4000);
        console.log("ERROR")
        console.log(error)
        console.log("TRAMITE NO PROCESADOR")
        console.log(requestToSave)
      });
  }


  clearValidatorsAttachmentsFrm() {
    this.solicitudForm.get('attachmentForm.programTypeId').clearValidators();
    this.solicitudForm.get('attachmentForm.programTypeId').setErrors(null);
    this.solicitudForm.get('attachmentForm.programTypeId').updateValueAndValidity();

    this.solicitudForm.get('attachmentForm.titleTypeId').clearValidators();
    this.solicitudForm.get('attachmentForm.titleTypeId').setErrors(null);
    this.solicitudForm.get('attachmentForm.titleTypeId').updateValueAndValidity();

    this.solicitudForm.get('attachmentForm.typeProfessionalId').clearValidators();
    this.solicitudForm.get('attachmentForm.typeProfessionalId').setErrors(null);
    this.solicitudForm.get('attachmentForm.typeProfessionalId').updateValueAndValidity();

    this.solicitudForm.get('attachmentForm.titleProfessionalName').clearValidators();
    this.solicitudForm.get('attachmentForm.titleProfessionalName').setErrors(null);
    this.solicitudForm.get('attachmentForm.titleProfessionalName').updateValueAndValidity();

    this.solicitudForm.get('attachmentForm.titleDoctorateName').clearValidators();
    this.solicitudForm.get('attachmentForm.titleDoctorateName').setErrors(null);
    this.solicitudForm.get('attachmentForm.titleDoctorateName').updateValueAndValidity();

    this.solicitudForm.get('attachmentForm.otherProfessionalName').clearValidators();
    this.solicitudForm.get('attachmentForm.otherProfessionalName').setErrors(null);
    this.solicitudForm.get('attachmentForm.otherProfessionalName').updateValueAndValidity();
  }

  validacionesCamposPostgradoUOtroProfesional() {
    if (this.solicitudForm.get('attachmentForm.programTypeId').value == '3') {
      this.solicitudForm.get('attachmentForm.titleDoctorateName').setValidators([Validators.required, Validators.minLength(5)]);
    } else {
      this.solicitudForm.get('attachmentForm.titleDoctorateName').clearValidators();
      this.solicitudForm.get('attachmentForm.titleDoctorateName').setErrors(null);
      this.solicitudForm.get('attachmentForm.titleDoctorateName').updateValueAndValidity();
      this.solicitudForm.get('attachmentForm.titleDoctorateName').setValue(null);
    }

    if (this.solicitudForm.get('attachmentForm.typeProfessionalId').value == '4') {
      this.solicitudForm.get('attachmentForm.otherProfessionalName').setValidators([Validators.required, Validators.minLength(5)]);
    } else {
      this.solicitudForm.get('attachmentForm.otherProfessionalName').clearValidators();
      this.solicitudForm.get('attachmentForm.otherProfessionalName').setErrors(null);
      this.solicitudForm.get('attachmentForm.otherProfessionalName').updateValueAndValidity();
      this.solicitudForm.get('attachmentForm.otherProfessionalName').setValue(null);
    }
  }

  setOrRemoveValidatorsInModify(action: number = 1) {
    if (action == 1) {
      this.solicitudForm.get('modificationForm.reasonModificationId').setValidators([Validators.required]);
      this.solicitudForm.get('modificationForm.reasonModificationId').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.resolutionToModify').setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
      this.solicitudForm.get('modificationForm.resolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.dateResolutionToModify').setValidators([Validators.required, super.dateValidator]);
      this.solicitudForm.get('modificationForm.dateResolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.licenciaVigenteFile').setValidators([Validators.required]);
      this.solicitudForm.get('modificationForm.licenciaVigenteFile').updateValueAndValidity();

      if (this.isLegalPerson) {
        this.solicitudForm.get('modificationForm.soporteModificacionFile').setValidators([Validators.required]);
        this.solicitudForm.get('modificationForm.soporteModificacionFile').updateValueAndValidity();
      }

    } else {
      this.solicitudForm.get('modificationForm.reasonModificationId').clearValidators();
      this.solicitudForm.get('modificationForm.reasonModificationId').setErrors(null);
      this.solicitudForm.get('modificationForm.reasonModificationId').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.resolutionToModify').clearValidators();
      this.solicitudForm.get('modificationForm.resolutionToModify').setErrors(null);
      this.solicitudForm.get('modificationForm.resolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.dateResolutionToModify').clearValidators();
      this.solicitudForm.get('modificationForm.dateResolutionToModify').setErrors(null);
      this.solicitudForm.get('modificationForm.dateResolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.licenciaVigenteFile').clearValidators();
      this.solicitudForm.get('modificationForm.licenciaVigenteFile').setErrors(null);
      this.solicitudForm.get('modificationForm.licenciaVigenteFile').updateValueAndValidity();

      this.solicitudForm.get('modificationForm.soporteModificacionFile').clearValidators();
      this.solicitudForm.get('modificationForm.soporteModificacionFile').setErrors(null);
      this.solicitudForm.get('modificationForm.soporteModificacionFile').updateValueAndValidity();

      this.solicitudForm.get('modificationForm').reset();
    }
  }

  setOrRemoveValidatorsInRenew(action: number = 1) {
    if (action == 1) {
      this.solicitudForm.get('renewalForm.renovationDepartmentId').setValidators([Validators.required]);
      this.solicitudForm.get('renewalForm.renovationDepartmentId').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.renovationMunicipalityId').setValidators([Validators.required]);
      this.solicitudForm.get('renewalForm.renovationMunicipalityId').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.resolutionToModify').setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
      this.solicitudForm.get('renewalForm.resolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.dateResolutionToModify').setValidators([Validators.required, super.dateValidator]);
      this.solicitudForm.get('renewalForm.dateResolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.licenciaAnteriorFile').setValidators([Validators.required]);
      this.solicitudForm.get('renewalForm.licenciaAnteriorFile').updateValueAndValidity();

    } else {
      this.solicitudForm.get('renewalForm.renovationDepartmentId').clearValidators();
      this.solicitudForm.get('renewalForm.renovationDepartmentId').setErrors(null);
      this.solicitudForm.get('renewalForm.renovationDepartmentId').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.renovationMunicipalityId').clearValidators();
      this.solicitudForm.get('renewalForm.renovationMunicipalityId').setErrors(null);
      this.solicitudForm.get('renewalForm.renovationMunicipalityId').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.resolutionToModify').clearValidators();
      this.solicitudForm.get('renewalForm.resolutionToModify').setErrors(null);
      this.solicitudForm.get('renewalForm.resolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.dateResolutionToModify').clearValidators();
      this.solicitudForm.get('renewalForm.dateResolutionToModify').setErrors(null);
      this.solicitudForm.get('renewalForm.dateResolutionToModify').updateValueAndValidity();

      this.solicitudForm.get('renewalForm.licenciaAnteriorFile').clearValidators();
      this.solicitudForm.get('renewalForm.licenciaAnteriorFile').setErrors(null);
      this.solicitudForm.get('renewalForm.licenciaAnteriorFile').updateValueAndValidity();
      this.solicitudForm.get('renewalForm').reset();
    }
  }

  setOrRemoveValidatorsIfWorking(action: number = 1) {
    if (action == 1) {

      this.solicitudForm.get('laborForm.companyWorking').setValidators([Validators.required]);
      this.solicitudForm.get('laborForm.companyWorking').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyName').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(100)]);
      this.solicitudForm.get('laborForm.companyName').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyAddress').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(100)]);
      this.solicitudForm.get('laborForm.companyAddress').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyDepartmentId').setValidators([Validators.required]);
      this.solicitudForm.get('laborForm.companyDepartmentId').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyMunicipalityId').setValidators([Validators.required]);
      this.solicitudForm.get('laborForm.companyMunicipalityId').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyPhone').setValidators([Validators.required, Validators.minLength(7), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      this.solicitudForm.get('laborForm.companyPhone').updateValueAndValidity();

      this.solicitudForm.get('laborForm.companyCellPhone').setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")]);
      this.solicitudForm.get('laborForm.companyCellPhone').updateValueAndValidity();
    } else {
      this.solicitudForm.get('laborForm.companyName').clearValidators();
      this.solicitudForm.get('laborForm.companyName').setErrors(null);
      this.solicitudForm.get('laborForm.companyName').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyName').setValue('');

      this.solicitudForm.get('laborForm.companyAddress').clearValidators();
      this.solicitudForm.get('laborForm.companyAddress').setErrors(null);
      this.solicitudForm.get('laborForm.companyAddress').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyAddress').setValue('');

      this.solicitudForm.get('laborForm.companyDepartmentId').clearValidators();
      this.solicitudForm.get('laborForm.companyDepartmentId').setErrors(null);
      this.solicitudForm.get('laborForm.companyDepartmentId').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyDepartmentId').setValue(null);

      this.solicitudForm.get('laborForm.companyMunicipalityId').clearValidators();
      this.solicitudForm.get('laborForm.companyMunicipalityId').clearValidators();
      this.solicitudForm.get('laborForm.companyMunicipalityId').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyMunicipalityId').setValue(null);

      this.solicitudForm.get('laborForm.companyPhone').clearValidators();
      this.solicitudForm.get('laborForm.companyPhone').setErrors(null);
      this.solicitudForm.get('laborForm.companyPhone').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyPhone').setValue(null);

      this.solicitudForm.get('laborForm.companyCellPhone').clearValidators();
      this.solicitudForm.get('laborForm.companyCellPhone').setErrors(null);
      this.solicitudForm.get('laborForm.companyCellPhone').updateValueAndValidity();
      this.solicitudForm.get('laborForm.companyCellPhone').setValue(null);


    }
  }

}
